import React, {useEffect, useState} from 'react'
import { Button, Input} from "reactstrap";
import {notSellers,newSeller} from 'network/ApiAxiosTickets'

function AddNewSellerDropdown(props) {
    const [users, setUsers] = useState()
    const [id, setId] = useState();

    useEffect(() => {
        getNotSellers()
      }, []);
    
      const getNotSellers = async()=>{
        const  response = await notSellers() 
        if(response.data.success){
            setUsers(response.data.users)
        }
      }

    const saveNewSeller =async()=>{
        if(!id || id =='1')return
        const resp = await newSeller(id)
        if(resp.data.success){
            props.toggle()
            setId('')
            setUsers('')
        }
    }

  return (
    <>
        <Input /*style={{width:props.width}}*/ type="select" onChange={(e)=>setId(e.target.value)} >
            {users && <option key="choose" value='1' label='Choose a Seller' />
            }
            {users && users.map((user)=>{
            return <option key={user._id} value={user._id} label={user.name} >{user.name}</option>
            })}
            
        </Input>
        <Button onClick={saveNewSeller}>Save</Button>
    </>
  )
}

export default AddNewSellerDropdown
